// extracted by mini-css-extract-plugin
module.exports = {"root":"TechWorksPopup_root__uk5rT","title":"TechWorksPopup_title__uQR4s","content":"TechWorksPopup_content__sZqS_","logo":"TechWorksPopup_logo__kxlix"};